import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RedirectService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';

@Component({
  selector: 'mnf-dashboard-v2-slides',
  standalone: true,
  imports: [
    CommonModule, 
    RouterModule,
    RouterModule,
  ],
  templateUrl: './dashboard-v2-slides.component.html',
  styleUrl: './dashboard-v2-slides.component.scss'
})
export class DashboardV2SlidesComponent implements OnInit {

  @Input() status!: { 
    isLead: boolean; 
    isInvestor: boolean; 
    isNotInvestor: boolean; 
    isFullGrowthLead: boolean; 
    isFullDomLead: boolean; 
    isFullLead: boolean; 
  };

  showCards = [];
  platformType: 'ios' | 'android' | 'web' = 'web';
  isNativePlatform: boolean = false;
  
  cardsPerStatus = [
    { isLead: [0, 1, 3] },
    { isInvestor: [0, 1, 2, 3, 4] },
    { isNotInvestor: [0, 1, 3, 4] },
    { isFullGrowthLead: [0, 1, 2, 3, 4] },
    { isFullDomLead: [0, 1, 2, 3, 4] },
    { isFullLead: [0, 1, 2, 3, 4] },
  ]

  constructor(
    private readonly modalServ: ModalService,
    private readonly redirectServ: RedirectService,
  ) {
    this.platformType = typeof cordova !== 'undefined' ? 'ios' : 'web';
  }
  
  cards = [
    {
      idCard: 0,
      title: '¡Monific se comparte!',
      description: 'Tu invitación es poderosa, invita a tus amigos a invertir con Monific.',
      image: 'https://static.monific.com/assets/assets-app/img/cards/home-card-1.webp',
      link: '/referenciados',
      textButton: '¡Hazlo aqui!',
      type: 'link',
    },
    {
      idCard: 1,
      title: 'Invertir al estilo Monific',
      description: 'Conoce cómo funciona Monific y los beneficios de invertir en bienes...',
      image: 'https://static.monific.com/assets/assets-app/img/cards/home-card-2.png',
      type: 'video',
      linkVideo: 'https://static.monific.com/assets/videos/Quiero_Invertir_Monific.mp4',
      textButton: 'Ver video',
    },
    {
      idCard: 2,
      title: '¡Invertir es MÁS fácil!',
      description: ' Con AutoGrowth, tus ahorros trabajan para ti, sin que...',
      image: 'https://static.monific.com/assets/assets-app/img/cards/home-card-3.png',
      type: 'link',
      link: '/mi-cuenta/ajustes/autoinversion',
      textButton: 'Conoce más'
    },
    {
      idCard: 3,
      title: '¡Tus inversiones a un clic! ',
      description: 'Descarga la app y haz que tu dinero trabaje para ti, estés...',
      image: 'https://static.monific.com/assets/assets-app/img/cards/home-card-4.png',
      type: 'download-app'
    },
    {
      idCard: 4,
      title: '¿Tienes dudas? 🤔',
      description: 'Visita nuestro Centro de Ayuda para encontrar respuestas rápidas.',
      image: 'https://static.monific.com/assets/assets-app/img/cards/home-card-5.png',
      link: 'https://centrodeayuda.monific.com/',
      type: 'href',
      textButton: 'Visitar ahora'
    },
  ]

  ngOnInit(): void {
    this.isNativePlatform = this.platformType === 'ios' || this.platformType === 'android';
    this.filterCardsByStatus();
  }

  filterCardsByStatus(): void {
    Object.keys(this.status)?.forEach((key) => {
      if (this.status?.[key]) {
        const statusCards = this.cardsPerStatus.find((item) => item[key]);
        if (statusCards) {
          this.showCards = this.cards.filter((card) => {
           const isAllowed = statusCards[key].includes(card?.idCard);
           const showMobileCard = this.isNativePlatform && card?.idCard === 3;
           return isAllowed && !showMobileCard; 
          });
        }
      }
    });
  }

  openVideo(link: string) {
    this.modalServ.openVideoModal(link, false);
  }

  openLink(url: string){
    this.redirectServ.openURL(url);
  }

}
